import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import {FinancialStatementsList} from "../../Partials/FinancialStatement/FinancialStatementsList";
import Constants from "../../../Action/Constants";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";

class OwnersReports extends Component {
  public state = {
    id: null,
    financialStatements: [],
    company: null
  }

  constructor(public props) {
    super(props);
  }

  public componentWillMount = () => {
    const id = parseInt(this.props.params.id, 10);
    const company = this.props.app.companies.filter(
      (company: CompanyInterface) => company.id === id
    )[0];

    this.setState({
      id: id,
      company: company
    });

    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
      payload: {
        ownerId: id
      },
      onSuccess: data => this.setState({financialStatements: [...data.financialStatements]})
    });
  }

  public renderOnwerReports() {
    return (
      <div>
        <div className="component-wrapper no-margins">
          <FinancialStatementsList
            {...this.props}
            id={this.state.id}
            financialStatements={this.state.financialStatements}
          />
        </div>
      </div>
    );
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full has-details-page-header ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header has-back-button two-row-title">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.state.company && this.state.company.displayName}</h1>
            </div>
            <div className="inner-wrapper">
              <h4>{this.trans("owner-statements-subtitle")}</h4>
            </div>
          </div>

          <div>
            <div style={{width: "100%"}} className="box component-company-update">
              <div className="component-wrapper no-margin-top no-shadow">
                {this.renderOnwerReports()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.ownerStatements,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  OwnersReports
);